import { faFlag } from '@fortawesome/free-regular-svg-icons'
import { useState } from 'react'

import FlagFraudSidebar from '@/components/Fraud/FraudFlagSidebar'
import IconButton from '@/components/IconButton'
import type { Applicant } from '@/lib/apollo/query/get-applicant'

interface Props {
  applicant: Applicant
}

const Fraud = ({ applicant }: Props) => {
  const [fraudSidebarOpen, setFraudSidebarOpen] = useState(false)

  return (
    <>
      <IconButton
        tooltipMessage="Potential fraudulence"
        icon={faFlag}
        onClick={() => setFraudSidebarOpen(true)}
      />
      <FlagFraudSidebar
        isOpen={fraudSidebarOpen}
        subjectId={applicant.id}
        customerId={applicant.customerId}
        onClose={() => setFraudSidebarOpen(false)}
        fraudStatus={applicant.fraudStatus}
        fraudReason={applicant.fraudReason}
        fraudDecision={applicant.fraudDecision}
      />
    </>
  )
}

export default Fraud
